<template>
  <div class="share-setting-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="left">
          <div class="title">上传公众号二维码</div>
          <el-form
            :model="configure"
            label-width="150px"
            label-position="right"
            :rules="rules"
            ref="form"
            class="configure-form"
          >
            <el-form-item class="img_item" prop="pic" label="二维码：">
              <div class="addImg">
                <p class="tips">推荐大小1000px*1000px</p>
                <div class="img-box">
                  <img
                    ref="img"
                    class="img"
                    :src="info1.codePic"
                    v-if="info1.codePic"
                  />
                  <div class="icon" v-else>
                    <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                    <p>图片</p>
                    <p class="tip">支持扩展名：.jpg .png</p>
                  </div>
                  <input
                    type="file"
                    class="file"
                    ref="img"
                    accept="image/png, image/jpg, image/jpeg"
                    @change="addChangeImg"
                  />
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item
              label="客服电话："
              prop="slogan"
              class="form-item"
            >
              <el-input
                size="small"
                placeholder="输入客服电话"
                class="input"
                v-model="info1.phone"
                style="width: 270px"
              ></el-input>
            </el-form-item> -->
          </el-form>
          <div class="btn-box">
            <button class="btn" @click="handleConfirm(1)">保存设置</button>
          </div>
        </div>
        <!-- <div class="right">
          <div class="title">公司开票信息</div>
          <el-form
            :model="info2"
            label-width="150px"
            label-position="right"
            :rules="rules"
            ref="form"
            class="configure-form"
          >
            <el-form-item label="公司名称" prop="name" class="form-item">
              <el-input
                placeholder="请输入公司名称"
                class="input"
                v-model="info2.name"
                style="width: 356px"
              ></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="taxId" class="form-item">
              <el-input
                placeholder="请输入纳税人识别号"
                class="input"
                v-model="info2.taxId"
                style="width: 356px"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司联系方式" prop="contact" class="form-item">
              <el-input
                placeholder="请输入公司联系方式"
                class="input"
                v-model="info2.contact"
                style="width: 356px"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司地址" prop="address" class="form-item">
              <el-input
                placeholder="公司地址"
                class="input"
                v-model="info2.address"
                style="width: 356px"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="bank" class="form-item">
              <el-input
                placeholder="请输入开户行"
                class="input"
                v-model="info2.bank"
                style="width: 356px"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行帐号" prop="accountNo" class="form-item">
              <el-input
                placeholder="请输入开户行帐号"
                class="input"
                v-model="info2.accountNo"
                style="width: 356px"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="btn-box">
            <button class="btn" @click="handleConfirm(2)">保存设置</button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'share-setting',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '公众号二维码'
      },
      configure: {
        pic: '',
        slogan: ''
      },
      rules: {},
      loading: 0,
      info1: {
        codePic: '',
        // phone: '',
      },
      info2: {
        name: '',
        taxId: '',
        contact: '',
        address: '',
        bank: '',
        accountNo: ''
      }
    };
  },
  mounted() {
    this.getPublicCodeInfo();
  },
  computed: {},
  methods: {
    // 获取分享详情
    getPublicCodeInfo() {
      this.loading++;
      this.httpGet(this.$root.getPublicCodeInfo, {}).then(
        (res) => {
          this.loading--;
          let info1 = {...this.info1};
          for(let key in info1){
            info1[key] = res[key];
          };
          this.info1 = info1;
          // let info2 = {...this.info2};
          // for(let key in info2){
          //   info2[key] = res[key];
          // };
          // this.info2 = info2;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 保存修改
    handleConfirm(way) {
      this.loading++;
      let inputData = {};
      way === 1 ? (inputData = this.info1) : (inputData = this.info2);
      this.httpPut(this.$root.updatePublicCode, {
        way: way,
        ...inputData
      }).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getPublicCodeInfo();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.info1, 'codePic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.img.value = '';
        // this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-form-item{
    margin-bottom: 20px !important;
}
.share-setting-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
    //   background: white;
      box-sizing: border-box;
    //   padding: 24px;
      border-radius: 2px;
      flex-x();

      .left, .right{
        flex: 1;
        background: #fff;
        height: 100%;
        padding: 30px;
        box-sizing: border-box;
      }
      .left{
          margin-right: 10px;
      }

      .right{
          margin-left: 10px;
      }

      .title {
        word(20px, #404157);
        font-weight: 550;
      }

      .configure-form {
        margin: 50px 80px 0;

        .input {
          width: 150px;
        }
      }

      .tip {
        word(15, #EA0000);
        margin-top: 24px;
        margin-left: 80px;
      }

      .btn-box {
        .btn {
          confirm-btn();
          width: 145px;
          height: 32px;
          margin-top: 24px;
          margin-left: 190px;
        }
      }

      .addImg {
        .tips {
          // margin-bottom: 12px;
          line-height: 40px;
        }

        .icon {
          width: 250px;
          height: 250px;
        }

        .img {
          width: 250px;
          height: auto;
        }

        p {
          margin: 0;
        }

        .tip {
          color: gray9;
        }
      }
    }
  }
}
</style>
